import React, { useEffect, useMemo, useState } from "react";
import { Avatar, Box, Chip, Grid, Typography, Button, Tabs, Tab, IconButton, Popper, Grow, Paper, TextField, Stack, Collapse, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, keyframes, Popover, FormControlLabel, Checkbox } from "@mui/material";
import TableComponent from "components/grid";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { MdDeleteOutline } from "react-icons/md";
import StatusBadge from "components/badge/StatusBadge";
import AddActionTracker from "./addTracker";
import { useParams } from "react-router-dom";
import moment from "moment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { usePermission } from "hooks/usePermission";
import { ACTION_TRACKER_CREATE, ACTION_TRACKER_DELETE, ACTION_TRACKER_EDIT, ACTION_TRACKER_VIEW } from "helpers/permissionConfig";
import { useGetAllProjectActionPendingApprovalQuery } from "store/slices/apis/projectActionDateChangeSlice";
import EditPendingApproval from "./editPendingApproval";



const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

);
const getDelayAvatar = (data) => {
    const dueDate = data.dueDate ? new Date(data.dueDate) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dueDate) dueDate.setHours(0, 0, 0, 0);
    if (dueDate && dueDate < today) {
        const diffMs = today - dueDate; // difference in milliseconds
        const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        return diffDays;
    } else {
        return 0;
    }
}
const getStatusColor = (data) => {
    if (!data) return "purple";

    const status = (data.status || "").toLowerCase();
    const dueDate = data.dueDate ? new Date(data.dueDate) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dueDate) dueDate.setHours(0, 0, 0, 0);


    // Case 1: In Progress & overdue
    if (status === "in progress" && dueDate && dueDate < today) {
        return { bg: "#FFD7D8", text: "#FF383C" };
    }

    // Case 2: In Progress & future due date
    if (status === "in progress" && dueDate && dueDate >= today) {
        return { bg: "orange", text: "white" };
    }

    // Case 3: Completed or Closed
    if (status === "completed" || status === "closed") {
        return { bg: "#E1FFBB", text: "#34A853" };
    }

    // Default
    return "purple";
};



const PendingApproval = (props) => {
    const { data } = props
    const { projectId } = useParams();
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [isDeleteModal, setDeleteModal] = useState(false);
    const dispatch = useDispatch();

    const reqBody = {
        projectId: projectId,
        projectActionId:data.projectActionId,
    }

    const { data: pendingApprovalData, isLoading, isError } = useGetAllProjectActionPendingApprovalQuery(reqBody)

    const createAccess = usePermission(ACTION_TRACKER_CREATE);
    const editAccess = usePermission(ACTION_TRACKER_EDIT);
    const deleteAccess = usePermission(ACTION_TRACKER_DELETE);
    const viewAccess = usePermission(ACTION_TRACKER_VIEW);


    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };

    const handleMenuView = () => {
        if (menuRow) {
            handleViewClick(menuRow);
        }
        handleMenuClose();
    };

    const handleMenuEdit = () => {
        if (menuRow) {
            handleEditTracker(menuRow);
        }
        handleMenuClose();
    };

    const [open, setOpen] = React.useState(false);

    const [tabValue, setTabValue] = useState(0);
    const anchorRef = React.useRef(null);

    const [selectedIndex, setSelectedIndex] = React.useState(1);

    const [isEditTracker, setIsEditTracker] = useState(false);
    const [isViewTracker, setIsViewTracker] = useState(false);
    const [rowData, setRowData] = useState(false);

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpen(false);
    };


    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };




    const handleEditTracker = (row) => {
        setIsEditTracker((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const handleViewClick = (row) => {
        setIsViewTracker((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }


    const handleMenuOpen = (event, row) => {
        event.stopPropagation();
        setMenuAnchorEl(event.currentTarget);
        setMenuRow(row);
    };



    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };


    const columns = [
        {
            name: "",
            field: "actions",
            width: "10px",
            sticky: true,
            renderer: (row) => {
                const currentStatus = row?.status?.toLowerCase()?.trim() || "";
                const isApproved = currentStatus === "approved" || currentStatus === "rejected" ;
                return (
                    <>
                        {((viewAccess || editAccess || deleteAccess) && !isApproved) &&
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <IconButton
                                    size="small"
                                    onClick={(e) => handleMenuOpen(e, row)}
                                >
                                    <MoreVertIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        }
                    </>
                );
            },
        },

        {
            name: "Requestor Name",
            field: "requesterName",
           
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px", whiteSpace: "pre-line" }}>
                    {row?.requesterName}
                </Box>
            ),
        },
          {
            name: 'Status',
            field: 'status',
            renderer: (row) => (
                <StatusBadge status={row.status} />
            )
        },
        {
            name: "Request Change Date",
            field: "requestChangeDate",
            // width: "200px",
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px", whiteSpace: "pre-line" }}>
                    {row.requestChangeDate ? moment(row.requestChangeDate).format("DD MMM YYYY") : "N/A"}

                </Box>
            ),
        },
        {
            name: "ApprovedDate/RejectedDate",
            field: "approvedDateRejectedDate",
            
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px", whiteSpace: "pre-line" }}>
                    {row.approvedDateRejectedDate ? moment(row.approvedDateRejectedDate).format("DD MMM YYYY") : "N/A"}
                </Box>
            ),
        }
    ];

    return (
        <>
            <Grid container spacing={2} sx={{ mt: '20px', p: 2 }}>
                <Grid size={8} sx={{ flex: 1 }}>
                    <Typography variant="h5" sx={{ mb: 0 }}>
                        Approval list
                    </Typography>
                </Grid>

                <Grid size={12}>
                    {/* {
                        tabValue === 0 &&
                        <> */}
                    <TableComponent
                        columns={columns}
                        data={pendingApprovalData?.data || []}
                        isLoading={isLoading}

                    />
                    <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                mt: 1,
                                borderRadius: "3px",
                                minWidth: 140,
                                border: "1px solid #E5E9EB",
                                boxShadow: "0px 10px 30px rgba(15, 23, 42, 0.12)",
                                overflow: "hidden",
                            },
                        }}
                        MenuListProps={{
                            sx: {
                                py: 0.5,
                            },
                        }}
                    >
                        {/* {viewAccess && <MenuItem
                            onClick={handleMenuView}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <LuEye size={16} style={{ color: "#4B5563" }} />
                            <span>View</span>
                        </MenuItem>
                        } */}

                        {editAccess &&
                            <MenuItem
                                onClick={handleMenuEdit}
                                sx={{
                                    fontFamily: "Outfit, sans-serif",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    px: 1.5,
                                    py: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    color: "#111827",
                                    "&:hover": {
                                        backgroundColor: "#F6F8F9",
                                    },
                                }}
                            >
                                <EditIcon style={{ width: 14, height: 14 }} />
                                <span>Edit</span>
                            </MenuItem>
                        }
                        {/* {deleteAccess && <MenuItem
                            onClick={handleDeleteActionTracker}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <MdDeleteOutline style={{ width: 14, height: 14 }} />
                            <span>Delete</span>
                        </MenuItem>} */}

                    </Menu>


                </Grid>
            </Grid >
            {
                isEditTracker &&
                <EditPendingApproval open={isEditTracker} handleClose={handleEditTracker} rowData={rowData} />
            }



        </>
    );
}

export default PendingApproval;